export default "__VITE_ASSET__ded76c33__"